import * as yup from 'yup';
import { PHONE_FIELD_ERROR } from './constants';

const phoneSchema = yup
  .string()
  .matches(/^\+\d\(\d{3}\)\d{7}$/, PHONE_FIELD_ERROR);

export default phoneSchema;
